import { __decorate } from "tslib";
import { RegisterServiceError, ServiceError, STATUS } from '@cbbt/lib-interface';
let OCISIndividualRecordLimitExceededError = class OCISIndividualRecordLimitExceededError extends ServiceError {
};
OCISIndividualRecordLimitExceededError = __decorate([
    RegisterServiceError({
        status: STATUS.BAD_REQUEST,
        message: 'More than 30 matches are found for the search criteria, Case referred to the colleague',
    })
], OCISIndividualRecordLimitExceededError);
export { OCISIndividualRecordLimitExceededError };
//# sourceMappingURL=OCISIndividualRecordLimitExceededError.js.map